import formsReducer, {
  disableForm,
  enableForm,
  clearForm,
  setFormErrors
} from "../lib/formsReducer";
import entitiesReducer from "../lib/entitiesReducer";
import * as actions from "./actions";
import * as pagesActions from "../pages/actions";
import { Record, Map, fromJS } from "immutable";
import { isApiCall } from "../app/schema";

import Forms from "./forms";
import PageTranslations from "./pageTranslations";

const feature = "pageTranslations";

const InitialState = Record({
  forms: new Forms(),
  pageTranslations: new PageTranslations()
});

const initialState = new InitialState();

function revive() {
  return initialState.merge({});
}

export default function PageTranslationsReducer(state = initialState, action) {
  if (!(state instanceof InitialState)) return revive(state);

  if (isApiCall(action.type)) {
    if (
      action.payload &&
      action.payload.entities &&
      action.payload.entities.pageTranslations
    ) {
      state = state.updateIn(["pageTranslations", "entities"], map =>
        map.mergeDeep(action.payload.entities.pageTranslations)
      );
    }
  }

  switch (action.type) {
    case actions.GET_PAGES_TRANSLATION: {
      return state.setIn(["pageTranslations", "loading"], true);
    }
    case actions.GET_PAGES_TRANSLATION_SUCCESS: {
      return state.setIn(["pageTranslations", "loading"], false);
    }
    case actions.GET_PAGES_TRANSLATION_ERROR: {
      return state.setIn(["pageTranslations", "loading"], false);
    }

    case actions.GET_PAGES_TRANSLATION_BY_UID: {
      return state.setIn(["pageTranslations", "loading"], true);
    }
    case actions.GET_PAGES_TRANSLATION_BY_UID_SUCCESS: {
      return state.setIn(["pageTranslations", "loading"], false);
    }
    case actions.GET_PAGES_TRANSLATION_BY_UID_ERROR: {
      return state.setIn(["pageTranslations", "loading"], false);
    }

    case actions.POST_PAGES_TRANSLATIONS: {
      return disableForm(state, "createPageTranslation");
    }
    case actions.POST_PAGES_TRANSLATIONS_SUCCESS: {
      state = clearForm(state, "createPageTranslation", Forms);
      return enableForm(state, "createPageTranslation");
    }
    case actions.POST_PAGES_TRANSLATIONS_ERROR: {
      state = enableForm(state, "createPageTranslation");
      return setFormErrors(
        state,
        "createPageTranslation",
        action.payload.errors
      );
    }

    case actions.PATCH_PAGES_TRANSLATION: {
      return state.setIn(["pageTranslations", "loading"], true);
    }
    case actions.PATCH_PAGES_TRANSLATION_SUCCESS: {
      return state.setIn(["pageTranslations", "loading"], false);
    }
    case actions.PATCH_PAGES_TRANSLATION_ERROR: {
      return state.setIn(["pageTranslations", "loading"], false);
    }

    case actions.DELETE_PAGES_TRANSLATION: {
      return state.deleteIn([
        "pageTranslations",
        "entities",
        action.payload.uid
      ]);
    }

    case actions.POST_PAGES_TRANSLATION_FIELDS: {
      return disableForm(state, "createPageTranslationsField");
    }
    case actions.POST_PAGES_TRANSLATION_FIELDS_SUCCESS: {
      state = clearForm(state, "createPageTranslationsField", Forms);
      return enableForm(state, "createPageTranslationsField");
    }
    case actions.POST_PAGES_TRANSLATION_FIELDS_ERROR: {
      state = enableForm(state, "createPageTranslationsField");
      return setFormErrors(
        state,
        "createPageTranslationsField",
        action.payload.errors
      );
    }

    case actions.SET_IS_EDIT_PAGE_TRANSLATION_MEDIA_FIELD_MODAL_VISIBLE: {
      return state.setIn(
        ["pageTranslations", "isEditMediaFieldModalVisible"],
        action.data.isVisible
      );
    }

    case actions.SET_IS_ADD_PAGE_TRANSLATION_MODAL_VISIBLE: {
      return state.setIn(
        ["forms", "createPageTranslation", "isAddModalVisible"],
        action.data.isVisible
      );
    }
    case actions.SET_IS_REMOVE_PAGE_TRANSLATION_MODAL_VISIBLE: {
      return state.setIn(
        ["pageTranslations", "isRemoveModalVisible"],
        action.data.isVisible
      );
    }
    case actions.SET_IS_EDIT_PAGE_TRANSLATION_MODAL_VISIBLE: {
      return state.setIn(
        ["pageTranslations", "isEditModalVisible"],
        action.data.isVisible
      );
    }

    case pagesActions.GET_PAGES: {
      return state.setIn(["pageTranslations", "loading"], true);
    }
    case pagesActions.GET_PAGES_SUCCESS: {
      let entities = new Map();
      for (let pageUID in action.payload.entities.pages) {
        entities = entities.set(
          pageUID,
          fromJS(action.payload.entities.pages[pageUID].pageTranslations)
        );
      }
      state = state.setIn(["pageTranslations", "entities"], entities);
      return state.setIn(["pageTranslations", "loading"], false);
    }
    case pagesActions.GET_PAGES_ERROR: {
      return state.setIn(["pageTranslations", "loading"], false);
    }
  }

  return entitiesReducer(
    formsReducer(state, feature, action, Forms),
    feature,
    action
  );
}



// WEBPACK FOOTER //
// ./src/common/pageTranslations/reducer.js